export default __webpack_public_path__ + "static/media/who.44f5d55f.png";